import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center" data-testid="auth-checking">
        <p className="text-ink-soft text-sm uppercase tracking-[0.2em]">Loading…</p>
      </div>
    );
  }
  if (!user || user.role !== "admin") {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  return children;
}
